import { styled } from '@vebox/etui-system';
import { Div } from '@vebox/etui-system-elements';

const ErrorLabel = styled(Div)`
  color: ${props => props.theme.palette.error.main};
  font-size: ${({
  theme
}) => theme.typography.fontSizeBase};
`;

export { ErrorLabel };
